import { initSupabaseClient } from '@leoclinic/services';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

/**
 * Indica se a app deve usar dados mock (sem Supabase configurado)
 */
export const USE_MOCK_DATA =
  import.meta.env.VITE_USE_MOCK_DATA === 'true' ||
  !supabaseUrl ||
  !supabaseAnonKey ||
  supabaseUrl.includes('your-project');

/**
 * Inicializa Supabase se configurado
 */
export function initializeApp(): void {
  if (!USE_MOCK_DATA) {
    initSupabaseClient({ url: supabaseUrl, anonKey: supabaseAnonKey });
  }
}

export const APP_NAME = import.meta.env.VITE_APP_NAME ?? 'LeoClinic';
